export default class CalendarDate {
  constructor(data = {}) {
    this.id = data.id;
    this.type = data.type;
    this.date = data.date;
  }

  static toJSON(data) {
    return {
      id: data.id,
      type: data.type || "",
      date: data.date,
    };
  }
}
